export default __webpack_public_path__ + "static/media/blog-single.c8f45f50.jpg";